import L from 'leaflet';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { GiHomeGarage } from "react-icons/gi";
import { IoBedOutline } from "react-icons/io5";
import { LiaBathSolid } from "react-icons/lia";
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';
import MarkerClusterGroup from "react-leaflet-cluster";
import 'react-leaflet-markercluster/dist/styles.min.css';
// import { useNavigate } from 'react-router-dom';
import { getMapListings } from '../service';
import MapBoundsLogger from './MapBoundsLogger'; // Import the MapBoundsLogger component
import { FilterContext } from './FilterContext';
import ChangeMapCenter from './changeMapCenter';

const MapComponent = ({ propertyType, location, priceRange, minPrice, maxPrice, beds, baths }) => {

  console.log("Range",minPrice,maxPrice);


  const {
    status,
    setStatus,
  } = useContext(FilterContext);


  const [Data, setData] = useState([]);
  const [polyganValue, setPolyganValue] = useState([[-79.3928178512883, 43.65790500294517], [-79.40145579410431, 43.651653527879944], [-79.38874165704074, 43.64991005052994], [-79.3928178512883, 43.65790500294517]]);


  const fetchData = useCallback(async () => {
    // Start building the query with polygon value
    let filterQuery = `${JSON.stringify([polyganValue])}`;  // stringified polygon
  
    // Add other query parameters
    if (propertyType) {
      filterQuery += `&propertyType=${propertyType}`;
    }
    if (location) {
      filterQuery += `&location=${location}`;
    }
  
    // Add price range filters if priceRange is provided, else use individual minPrice and maxPrice
    
      // If priceRange is not set, use the provided minPrice and maxPrice individually
      if (minPrice) {
        filterQuery += `&minPrice=${minPrice}`;
      }
      if (maxPrice) {
        filterQuery += `&maxPrice=${maxPrice}`;
      }
    
  
    if (beds) {
      filterQuery += `&beds=${beds}`;
    }
    if (baths) {
      filterQuery += `&baths=${baths}`;
    }
  
    // Handle the status filter (only if it's 'A', 'U', or 'D')
    if (status === 'A' || status === 'U' || status === 'D' || status === 'O') {
      filterQuery += `&status=${status}`;
    }
  
    console.log('filterQuery:', filterQuery);
  
    try {
      const dataList = await getMapListings(filterQuery);  // Ensure getMapListings handles the query
      setData(dataList);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }, [propertyType, location, priceRange, minPrice, maxPrice, beds, baths, polyganValue, status]);
  

  console.log(status);


  useEffect(() => {
    fetchData();
  }, [propertyType, location, priceRange, minPrice, maxPrice, beds, baths, polyganValue, status, fetchData]);

  const createCustomMarkerIcon = (label, price) => {
    return L.divIcon({
      html: `
                <div class="relative flex items-center bg-blue-700 text-white rounded-lg px-2 py-1 shadow-md w-28">
                    <div class="bg-white text-blue-700 font-bold rounded-md px-2 py-1 mr-2">${label}</div>
                    <div class="font-bold text-white">$ ${price}</div>
                    <div class="absolute bottom-[-10px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-blue-700"></div>
                </div>`,
      iconSize: [50, 50],
      iconAnchor: [25, 50],
    });
  };

  const createClusterCustomIcon = (cluster) => {
    const count = cluster.getChildCount();
    return L.divIcon({
      html: `<div class="flex items-center justify-center bg-blue-700 text-white rounded-full w-12 h-12">${count}</div>`,
      className: 'custom-cluster-icon',
      iconSize: L.point(45, 45, true),
    });
  };

  const formatPrice = (price) => {
    if (price >= 1000000) {
      return (price / 1000000).toFixed(1) + 'M';
    } else if (price >= 1000) {
      return Math.round(price / 1000) + 'K';
    } else {
      return price;
    }
  };

  const formatNumber = (num) => {
    const number = Number(num);
    return number % 1 === 0 ? number.toFixed(0) : number.toFixed(1);
  };

  const AdjustMapPaneZIndex = () => {
    const map = useMap();

    // Adjust zIndex for all panes
    map.getPane('tilePane').style.zIndex = -1000;
    map.getPane('overlayPane').style.zIndex = -1000;
    map.getPane('shadowPane').style.zIndex = -1000;
    map.getPane('markerPane').style.zIndex = -1000;
    map.getPane('tooltipPane').style.zIndex = -1000;
    map.getPane('popupPane').style.zIndex = -1000;

    return null;
  };

  // Calculate mapCorinates inside the render logic
  const mapCorinates = Data.data?.listings ? Data.data.listings.map((item) => ({
    lat: item.map.latitude,
    lng: item.map.longitude,
    propertyPrice: item.listPrice,
    propertyType: item.details.propertyType,
    price: formatPrice(item.listPrice),
    images: item.images,
    mlsNumber: item.mlsNumber,
    title: item.details.propertyType.charAt(0), // Just an example for title
    address: `${item.address.streetNumber} ${item.address.streetName}, ${item.address.city}, ${item.address.zip}`,
    bathroomsCount: item.details.numBathrooms,
    roomsCount: item.details.numBedrooms,
    garage: item.details.numGarageSpaces || item.details.numParkingSpaces !== null
      ? `${formatNumber(item.details.numParkingSpaces)} + ${formatNumber(item.details.numGarageSpaces)}`
      : 0,
  })) : [];

  const [loading, setLoading] = useState(true)

  const ForceMapResize = () => {
    const map = useMap();

    useEffect(() => {
      setTimeout(() => {
        map.invalidateSize();
      }, 300); // Delay to ensure container has mounted
    }, [map]);

    return null;
  };



  //   const ChangeMapCenter = ({ center }) => {
  //     const map = useMap();
  //     const previousCenter = useRef(null);

  //     useEffect(() => {
  //         const hasCenterChanged =
  //             !previousCenter.current ||
  //             previousCenter.current[0] !== center[0] ||
  //             previousCenter.current[1] !== center[1];

  //         if (hasCenterChanged) {
  //             console.log("Map center changed, updating view:", center);
  //             map.setView(center);
  //             previousCenter.current = center;
  //         } else {
  //             console.log("Map center has not changed:", center);
  //         }
  //     }, [center, map]);


  //     return null;
  // };






  // const navigate = useNavigate();
  const coords = [
    {
      name: 'Toronto',
      coord: [43.7205208, -79.3878583]
    },
    {
      name: 'Muskoka',
      coord: [44.901642, -79.575821]
    },
    {
      name: 'Oakville',
      coord: [43.4675, -79.6877]
    },
    {
      name: 'Kawartha Lakes',
      coord: [44.3000, -78.9006]
    },
    {
      name: 'Mississauga',
      coord: [43.5890, -79.6441]
    },
    {
      name: 'Brampton',
      coord: [43.7333, -79.7667]
    },
    {
      name: 'Hamilton',
      coord: [43.2500, -79.8667]
    },
    {
      name: 'Markham',
      coord: [43.8667, -79.2667]
    },
    {
      name: 'Vaughan',
      coord: [43.8333, -79.5000]
    },
    {
      name: 'Burlington',
      coord: [43.3256, -79.8017]
    },
    {
      name: 'Richmond Hill',
      coord: [43.8833, -79.4500]
    },
    {
      name: 'Oshawa',
      coord: [43.8967, -78.8667]
    },
    {
      name: 'Ajax',
      coord: [43.8500, -79.0333]
    },
    {
      name: 'Pickering',
      coord: [43.8333, -79.0833]
    },
    {
      name: 'Whitby',
      coord: [43.8833, -78.9333]
    },
    {
      name: 'Milton',
      coord: [43.5167, -79.8833]
    },
    {
      name: 'Newmarket',
      coord: [44.0500, -79.4667]
    },
  ];

















  const [coorinates, setCoordinates] = useState([43.7205208, -79.3878583]);

  useEffect(() => {
    setLoading(true)
    console.log("Location:", location);
    const matchedLocation = coords.find(item => item.name.toLowerCase() === location?.toLowerCase());
    if (matchedLocation) {
      console.log("Matched:", matchedLocation);
      setCoordinates(matchedLocation.coord);
    } else {
      setCoordinates([43.7205208, -79.3878583]);

    }
    setLoading(false)


  }, [location]);

  console.log("Mapped Coordinates:", coorinates);





  return (
    loading ?
      <div>Loading</div>
      :
      <MapContainer
        center={coorinates}
        zoom={10}
        style={{ height: '100%', width: '100%' }}
      >
        <ChangeMapCenter center={coorinates} />

        <TileLayer
          zIndex={-1000}
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <MapBoundsLogger setPolyganValue={setPolyganValue} />
        <AdjustMapPaneZIndex />
        <MarkerClusterGroup chunkedLoading iconCreateFunction={createClusterCustomIcon}>
          {mapCorinates.map((position, index) => (
            <Marker key={index} position={[position.lat, position.lng]} icon={createCustomMarkerIcon(position.title, position.price)}>
              <Popup className='leafletPopup'>
                <div className="flex flex-row w-96 gap-2 border border-gray-300 rounded-xl p-2 font-open-sans cursor-pointer" onClick={() => window.open(`/property/${position.mlsNumber}`, '_blank')}>
                  <img src={position.images[0]} alt="home" className="w-28 h-28 object-cover rounded-lg" />
                  <div className="flex flex-col gap-2">
                    <h3 className="text-base font-bold">$ {position.propertyPrice}</h3>
                    <p className='text-xs mr-0'>{position.address}</p>
                    <div className='flex items-center divide-x-2 gap-3'>
                      <div className='flex items-center gap-1'>
                        <IoBedOutline />
                        <span>{position.roomsCount}</span>
                      </div>
                      <div className='flex items-center gap-1 pl-2'>
                        <LiaBathSolid />
                        <span>{position.bathroomsCount}</span>
                      </div>
                      <div className='flex items-center gap-1 pl-2'>
                        <GiHomeGarage />
                        <span>{position.garage}</span>
                      </div>
                    </div>
                    <p>{position.propertyType}</p>
                  </div>
                </div>
              </Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainer>
  );
};

export default MapComponent;